import React from "react";
import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import api from "../../api";
import IconButton from "@mui/material/IconButton";
import { grey, red } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import "./like_coment.css";
import DeleteIcon from "@mui/icons-material/Delete";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   increment,
//   decrement,
//   valueInitial,
// } from "../../store/counterComentLikeSelector";

const Lenta_text = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0),
  // margin: 0,
  marginTop: 3,
  textAlign: "center",
  color: grey[400],
  fontSize: "0.9rem",
  fontFamily: "Roboto",
}));

const Lenta_Stack = styled(Stack)(({ theme }) => ({
  // margin: 0,
  // textAlign: "center",
  // color: grey[400],
  // fontSize: "0.9rem",
  // fontFamily: "Roboto",
}));
const LikeComent = ({ data }) => {
  // const dispatch = useDispatch();
  const [like, setLike] = useState(getCookie() ? getCookie() : []);
  const [isDisabled, setDisabled] = useState(false);
  // const countLikeRedux = useSelector(
  //   (state) => state.counterComentLikeSelector.counter,
  // );

  const [countLike, setCountLike] = useState(data.like);

  function getCookie() {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, 5) === "fprz=") {
          cookieValue = decodeURIComponent(cookie.substring(5));
          cookieValue = cookieValue.split(",");
          break;
        }
      }
    }
    return cookieValue;
  }
  const sendCountLike = () => {
    setDisabled(true);
    api.sendLikeComent(countLike, data.id).then((response) => {
      if (response.status === 200) {
        setDisabled(false);
      } else {
        setDisabled(false);
      }
    });
  };

  const editCookie = (like) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 150);
    const expires = expirationDate.toUTCString();
    document.cookie = "fprz" + "=" + like + ";" + expires + ";path=/";
  };

  const changeLike = (name) => {
    if (like.includes(name)) {
      setLike(like.filter((task) => task !== name));
      // setCountLike(countLike - 1);
      setCountLike((n) => n - 1);
      // dispatch(decrement());
      console.log(countLike);
    } else {
      setLike((current) => [...current, name]);
      // setCountLike((countLike) => countLike + 1);
      // setCountLike(countLike + 1);
      setCountLike((n) => n + 1);
      // dispatch(increment());
      console.log(countLike);
    }
  };

  // const changeLike = () => {
  //   return api.changeLike_Coment();
  // };
  // console.log({ data });
  useEffect(() => {
    // dispatch(valueInitial(data.like));
    sendCountLike(countLike);
    // setCountLike(data.like);
    // setCountLike(countLike);
    editCookie(like);
  }, [like, countLike]);
  return (
    <Lenta_Stack direction="row" className="stack">
      <div className="zoom-effect">
        {like.includes(data.created_time) ? (
          <IconButton
            disabled={isDisabled}
            aria-label="нравится"
            onClick={() => changeLike(data.created_time)}
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 512 512"
              fill={grey[500]}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m126.06 177.71h-43.06v55a15 15 0 0 1 -30 0v-55h-38a15 15 0 0 0 -15 15v280a15 15 0 0 0 15 15h111.06z" />
              <path d="m407 409.85a15 15 0 0 1 0-30h105v-70h-105a15 15 0 0 1 0-30h105v-47.14a55.06 55.06 0 0 0 -55-55h-41.58v25a15 15 0 0 1 -30 0v-127.71a75.09 75.09 0 0 0 -75-75h-6a35 35 0 0 0 -35 35v97.71a45.05 45.05 0 0 1 -45 45h-68.36v317.2l32.32 13.09a54.87 54.87 0 0 0 20.62 4h248a55.06 55.06 0 0 0 55-55v-47.15z" />
            </svg>
          </IconButton>
        ) : (
          <IconButton
            disabled={isDisabled}
            aria-label="нравится"
            onClick={() => changeLike(data.created_time)}
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill={grey[500]}
            >
              <path d="m457 177.71h-71.59v-102.71a75.09 75.09 0 0 0 -75-75h-6a35 35 0 0 0 -35 35v97.71a45.05 45.05 0 0 1 -45 45h-209.41a15 15 0 0 0 -15 15v280a15 15 0 0 0 15 15h123.14l50.24 20.29a54.87 54.87 0 0 0 20.62 4h248a55.06 55.06 0 0 0 55-55v-224.29a55.06 55.06 0 0 0 -55-55zm-427 30h33v25a15 15 0 0 0 30 0v-25h33v250h-96zm427 274.29h-248a24.67 24.67 0 0 1 -9.37-1.83l-43.58-17.63v-254.83h68.35a75.09 75.09 0 0 0 75-75v-97.71a5 5 0 0 1 5-5h6a45 45 0 0 1 45 45v157.71a15 15 0 0 0 30 0v-25h71.6a25 25 0 0 1 25 25v47.14h-75a15 15 0 0 0 0 30h75v70h-75a15 15 0 0 0 0 30h75v47.15a25 25 0 0 1 -25 25z" />
            </svg>
          </IconButton>
        )}
      </div>
      <div className="zoom-effect">
        <Lenta_text>{countLike}</Lenta_text>
      </div>
    </Lenta_Stack>
  );
};

export default LikeComent;
